import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

/** Quiet empty / loading state. */
export function EmptyState({
  icon = 'stack',
  title,
  hint,
  action,
}: {
  icon?: IconName;
  title: ReactNode;
  hint?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 10,
        padding: '46px 20px',
        color: 'var(--ink-3)',
      }}
    >
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: 13,
          background: 'var(--paper-2)',
          display: 'grid',
          placeItems: 'center',
          color: 'var(--ink-4)',
        }}
      >
        <Icon name={icon} size={22} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--ink-2)' }}>{title}</div>
      {hint && <div style={{ fontSize: 13, maxWidth: 280 }}>{hint}</div>}
      {action}
    </div>
  );
}

/** Inline spinner row for query loading. */
export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        padding: '40px 20px',
        color: 'var(--ink-3)',
        fontSize: 14,
      }}
    >
      <span
        style={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          border: '2px solid var(--line-2)',
          borderTopColor: 'var(--sage)',
          animation: 'spin .7s linear infinite',
        }}
      />
      {label}
      <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
    </div>
  );
}
